module.exports = new __parcel__URL__("shop_machines_photon_shield.ccfd5f95.png").toString();